import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { propertyAddressAsyncValidator } from '@shared/validators/property-address.async.validator';
import {
  Collection,
  Property,
  PropertyAddForm,
  PropertyCategory,
  PropertyCategoryService,
  PropertyService,
} from 'taxtank-core';
import { takeUntil } from 'rxjs/operators';
import { BaseFormComponent } from '@shared/component/base/base-form.component';

const MESSAGE_ADDED = 'Properties saved';

@Component({
  selector: 'app-property-add-form',
  templateUrl: './property-add-form.component.html',
  styleUrls: ['./property-add-form.component.scss'],
  standalone: false
})
export class PropertyAddFormComponent extends BaseFormComponent implements OnInit {
  @ViewChild(FormGroupDirective) formRef: FormGroupDirective;
  @Output() saved: EventEmitter<Property> = new EventEmitter<Property>();
  form: PropertyAddForm;
  categories: Collection<PropertyCategory>;
  now: Date = new Date();

  constructor(private propertyCategoryService: PropertyCategoryService, private propertyService: PropertyService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.propertyCategoryService.get()
      .pipe(takeUntil(this.destroy$))
      .subscribe((categories: Collection<PropertyCategory>) => {
        this.categories = categories.sortBy('name');
      });

    this.form.get('address').setAsyncValidators(propertyAddressAsyncValidator(this.propertyService.getAll()));
  }

  buildForm(): void {
    this.form = new PropertyAddForm();
  }

  save(property: Property): void {
    this.propertyService.post(property).subscribe(property => {
      this.toastService.success(MESSAGE_ADDED);
      this.saved.emit(property);
    });
  }
}
